<template>
<div class="vliveAdv">
    <div>
        <!--<el-switch v-model="adv.isopenad" active-text="当前版本最多支持5个广告位" @change="switchStatus"></el-switch>-->
        <span class="switch"  @click.stop="switchStatus"><el-switch v-model="adv.isopenad" active-text="当前版本最多支持1个广告位" disabled></el-switch></span>
    </div>
    <div class="adv-lists" v-if="vliveModel.adv.isopenad">
        <div v-for="(item,index) in vliveModel.adv.list" :key="index" class="adv">
            <img :src="item.logourl +'?'+timestamp" alt="">
            <span class="link text-ellipse">{{item.redirecturl}}</span>
            <el-button @click="handleVliveAdvEdit(item)" type="text" size="small">编辑</el-button>
            <el-button @click="handleVliveAdvDel(item)" type="text" size="small">删除</el-button>
        </div>
        <div class="upload cover-image" @click="handleVliveAdvAdd" v-if="vliveModel.adv.list&&vliveModel.adv.list.length<1">
            <div class="avatar-uploader">
                <div class="el-upload el-upload--text">
                    <i class="el-icon-plus avatar-uploader-icon icon_upload"></i>
                </div>
            </div>
        </div>
    </div>
    <vliveAdvEdit ref="vliveAdvEdit" @addAdv="_addAdv" @editAdv="_editAdv"></vliveAdvEdit>
</div>
</template>

<script>
import VliveAdvEdit from 'views/cms/vlive/components/vliveAdvEdit'
import {mapGetters, mapActions} from 'vuex'
import {getVliveAdvList, editVliveAdvStatus, editVliveAdv, addVliveAdv, delVliveAdv} from 'api/api'
import {formatFileInfo} from 'common/js/tools'
import {vliveMsg} from 'api/message'
export default {
    name: 'vliveAdv',
    data() {
        return {
            timestamp: new Date().getTime(), // 时间戳
            adv: {
                isopenad: false,
                list: []
            },
            settingType: 'isopenad' // isopenpreview 预告片 isopencover 引导封面 isopenmp 关注公众号 isopenenroll 报名 isopenad 广告
        }
    },
    mounted() {
        this._getAdvList()
    },
    methods: {
        // 关闭/开启广告
        switchStatus() {
            let status = !this.adv.isopenad ? 1 : 0
            let tip = !this.adv.isopenad ? '开启广告' : '关闭广告'
            this.$confirm(`确定${tip}？`, '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定'
            }).then(() => {
                this._editStatus(status, tip)
            })
        },
        // 打开新增广告框
        handleVliveAdvAdd() {
            this.$refs.vliveAdvEdit.openDialog('add')
        },
        // 打开编辑广告框
        handleVliveAdvEdit(obj) {
            this.$refs.vliveAdvEdit.openDialog(obj)
        },
        // 删除广告
        handleVliveAdvDel(row) {
            this.$confirm(vliveMsg.delVliveAdv.msg, vliveMsg.delVliveAdv.title, {
                confirmButtonText: vliveMsg.delVliveAdv.confirmText,
                cancelButtonText: vliveMsg.delVliveAdv.cancelText
            }).then(() => {
                this._delVliveAdv(row)
            })
        },
        _delVliveAdv(row) {
            this.setLoading(true)
            delVliveAdv({
                data: {
                    innerid: row.innerid
                },
                success: data => {
                    this.setLoading(false)
                    this.$message.success(vliveMsg.delVliveAdv.successMsg)
                    this._getAdvList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 提交编辑后的广告
        _editAdv(obj) {
            this.timestamp = new Date().getTime()
            let tmp = obj
            tmp.coverPicture = formatFileInfo(obj.coverPicture)
            this.setLoading(true)
            editVliveAdv({
                data: Object.assign({}, obj),
                success: data => {
                    this.setLoading(false)
                    this._getAdvList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 提交新增的广告
        _addAdv(obj) {
            this.timestamp = new Date().getTime()
            let tmp = obj
            tmp.coverPicture = formatFileInfo(obj.coverPicture)
            this.setLoading(true)
            addVliveAdv({
                data: Object.assign({}, obj, {assetinnerid: this.vliveModel.assetinnerid}),
                success: data => {
                    this.setLoading(false)
                    this._getAdvList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 提交关闭/开启广告
        _editStatus(status, tip) {
            this.setLoading(true)
            editVliveAdvStatus({
                data: {
                    innerid: this.vliveModel.assetinnerid,
                    isopenad: status
                },
                success: data => {
                    this.$message.success(`${tip}成功！`)
                    this.adv.isopenad = !this.adv.isopenad
                    this.setVliveModelAdv(Object.assign({}, this.adv))
                    this.setLoading(false)
                },
                error: data => {
                    this.adv.isopenad = !this.adv.isopenad
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取广告列表
        _getAdvList() {
            this.setLoading(true)
            getVliveAdvList({
                data: {
                    assetinnerid: this.$route.query.id ? this.$route.query.id : ''
                },
                success: data => {
                    this.adv.list = data.data.content
                    this.setVliveModelAdv(Object.assign({}, this.adv))
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setVliveModelAdv',
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        vliveModel: {
            handler: function() {
                this.adv = Object.assign({}, this.vliveModel.adv)
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'vliveModel'
        ])
    },
    components: {
        VliveAdvEdit
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveAdv {
    .avatar-uploader{
        box-sizing: border-box;
        width: 300px;
        height: 40px;
    }
    .adv-lists{
        margin-top: 20px;
        .adv{
            @include flexBox(flex-start);
            padding: 10px 0;
            img{
                width: 300px;
                height: 40px;
            }
            .link{
                color: $tcolor-grey;
                font-size: $font-14;
                max-width: 220px;
                min-width: 220px;
                margin: 0 30px;
                display: inline-block;
            }
            .btn{
            }
        }
        .el-button, .el-button--mini{
            min-width: 40px;
        }
    }
}
</style>
